const middleware = {}

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['errorLayout'] = require('../middleware/errorLayout.js')
middleware['errorLayout'] = middleware['errorLayout'].default || middleware['errorLayout']

export default middleware
